import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
      
      <div className="prose max-w-none">
        <p className="text-gray-700 mb-6">Last updated: November 17, 2025</p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Introduction</h2>
        <p className="text-gray-700 mb-4">
          Welcome to Varmin Pharmaceuticals. These Terms of Service ("Terms") govern your access to and use of our website and services. By accessing or using our website, you agree to be bound by these Terms.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Use of Our Website</h2>
        <p className="text-gray-700 mb-4">
          You agree to use our website only for lawful purposes and in accordance with these Terms. You agree not to use our website:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
          <li>In any way that violates any applicable law or regulation</li>
          <li>To engage in any fraudulent or illegal activity</li>
          <li>To transmit any viruses or malicious code</li>
          <li>To interfere with or disrupt the security of the website</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Intellectual Property</h2>
        <p className="text-gray-700 mb-4">
          The content, organization, graphics, design, and other matters related to our website are protected under applicable copyrights, trademarks, and other proprietary rights. You may not copy, modify, distribute, or reproduce any content from our website without our prior written permission.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. Medical Disclaimer</h2>
        <p className="text-gray-700 mb-4">
          The information provided on this website is for general informational purposes only and is not intended as medical advice. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. Limitation of Liability</h2>
        <p className="text-gray-700 mb-4">
          In no event shall Varmin Pharmaceuticals, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the website.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. Changes to Terms</h2>
        <p className="text-gray-700 mb-4">
          We reserve the right to modify these Terms at any time. We will provide notice of any changes by updating the "Last updated" date. Your continued use of the website after such modifications constitutes your acceptance of the new Terms.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. Governing Law</h2>
        <p className="text-gray-700 mb-4">
          These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">8. Contact Us</h2>
        <p className="text-gray-700 mb-4">
          If you have any questions about these Terms, please contact us at:
        </p>
        <p className="text-gray-700">
          Varmin Pharmaceuticals Pvt. Ltd.<br />
          Email: varminpharmaceuticals@gmail.com<br />
          Phone: +91 94521 01977
        </p>
      </div>

      <div className="mt-12">
        <Link to="/" className="text-green-600 hover:underline">
          &larr; Back to Home
        </Link>
      </div>
    </div>
  );
};

export default TermsOfService;
